import { graphql } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC, useEffect } from 'react';
import AuthLoading from '../../../components/AuthLoading/AuthLoading';
import Layout from '../../../components/Layout/Layout';
import Seo from '../../../components/Seo/Seo';
import safeParse from '../../../utils/safeParse';
import translateService from '../../../utils/translateService';
import AnalyticsHeaders from '../BranchView/AnalyticsHeaders';

const BookView: FC<{ pageContext: { branch: Queries.CollarAPI_Branch; provider: Record<string, any> } }> = ({ pageContext, data }) => {
  const { branch, provider } = pageContext;
  const inWindow = typeof window !== 'undefined';
  const name = provider?.name || branch?.name;
  const { i18n, ready, t } = useTranslation();

  useEffect(() => {
    if (ready) {
      translateService.set(i18n);
    }
  }, [i18n.language, ready]);

  return (
    <Layout language={i18n.language}>
      {inWindow && ready ? (
        <AuthLoading branch={branch} provider={provider} />
      ) : (
        <div style={{ opacity: 0 }}>
          <span>{t('branchMetaDescription', { name })}</span>
        </div>
      )}
    </Layout>
  );
};

export const Head = ({ pageContext, data }) => {
  const { branch, provider } = pageContext;
  const name = provider?.name || branch?.name;
  const logo = provider?.branches?.[0]?.photos?.logo || branch?.photos?.logo;
  const analytics = provider?.branches?.[0]?.analytics || branch?.analytics;

  return (
    <Seo title={name} description={safeParse(data?.locales.edges[0]?.node.data)?.branchMetaDescription?.replace?.('{{name}}', name) || ''} image={logo}>
      <AnalyticsHeaders analytics={analytics} />
    </Seo>
  );
};

export default BookView;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
